// src/layouts/AdminLayout.js
import React from 'react'
import {Navigate, Outlet} from 'react-router-dom'
import Navbar from '../components/Navbar' // ajusta ruta si está en otro lado
import '../../src/pages/casino.css'
export default function AdminLayout() {
  return (
    <div className="app-background"> 
      <div className="app-content">
        <Navbar />
        <Outlet />
      </div>
    </div>
  )
}
